import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from 'sonner';
import { useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';

// Layout Components
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { CookieConsent } from "./components/CookieConsent";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
// import Training from "./pages/Training";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import Playground from "./pages/Playground";
import CaseStudies from "./pages/CaseStudies";
import ClientPortal from "./pages/ClientPortal";
import Auditor from "./pages/Auditor";
import Blog from "./pages/Blog";
import Privacy from "./pages/Privacy";

// Assistant widget
// import AIAssistantWidget from "./components/AIAssistantWidget";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

// Animated page wrapper
const AnimatedRoutes = () => {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        {/* <Route path="/training" element={<Training />} /> */}
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/playground" element={<Playground />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/portal" element={<ClientPortal />} />
        <Route path="/audit" element={<Auditor />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-[#030712]">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen">
          <AnimatedRoutes />
        </main>
        <Footer />
        <WhatsAppButton />
        <CookieConsent />
        {/* <AIAssistantWidget /> */}
      </BrowserRouter>
      <Toaster 
        position="top-right" 
        richColors 
        toastOptions={{
          style: {
            background: '#1e293b',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: '#f8fafc',
          },
        }}
      />
    </div>
  );
}

export default App;